import React, {useEffect, useRef, useState} from "react";
import { RoutineTasksScreen } from '../routine-tasks-screen'
import { IncreaseConversionScreen } from '../increase-conversion-screen'
import { QualityStandardsScreen } from '../quality-standards-screen'
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import Slider from "react-slick";
import { ImproveServiceScreenV2 } from "~/components/pages/index/components/improve-service-screen-v2";

const ServicesScreenGroup = () => {
  const isMobile = useIsMobile();
  const sliderRef = useRef(null)
  const tabRef = useRef([])
  const tabsRef = useRef(null)
  const [activeScreenIndex, setActiveScreenIndex] = useState(0)
  const servicesScreens = [
    {
      title: <span>Улучшите свой <StyledScreen.GreenText>сервис</StyledScreen.GreenText> с onlinepbx</span>,
      component: <ImproveServiceScreenV2 />
    },
    {
      title: <span><StyledScreen.GreenText>Автоматизируйте</StyledScreen.GreenText> рутинные задачи</span>,
      component: <RoutineTasksScreen />
    },
    {
      title: <span>Увеличьте <StyledScreen.GreenText>конверсию</StyledScreen.GreenText></span>,
      component: <IncreaseConversionScreen />
    },
    {
      title: <span>Внедрите <StyledScreen.GreenText>стандарты</StyledScreen.GreenText> качества</span>,
      component: <QualityStandardsScreen />
    }
  ]

  useEffect(() => {
    if (tabsRef.current && tabRef.current.length > 0) {
      const container = tabsRef.current;
      const tab = tabRef.current[activeScreenIndex];

      container.scrollTo({
        top: 0,
        left: Math.max(tab.offsetLeft, tab.offsetLeft),
        behavior: 'smooth'
      })
    }
  }, [activeScreenIndex, tabRef, tabsRef])

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    useCSS: true,
    fade: false,
    adaptiveHeight: true,
    appendDots: (dots: any) => (
      <Styled.Dots>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </Styled.Dots>
    ),
    customPaging: (i: number) => (
      <Styled.Dot />
    ),
    beforeChange: (current: number, next: number) => setActiveScreenIndex(next)
  };

  const onClickTab = (index: number) => {
    if (sliderRef) sliderRef.current.slickGoTo(index)
  }

  const renderMobile = () => {
    return (
      <>
        <Styled.Tabs>
          <Styled.TabsInner ref={tabsRef}>
            {
              servicesScreens.map((screen, index) => (
                <>
                  {
                    index === activeScreenIndex
                      ? <Styled.TabActive ref={el => tabRef.current[index] = el} ><Styled.TabTitle>{screen.title}</Styled.TabTitle></Styled.TabActive>
                      : <Styled.TabNonActive ref={el => tabRef.current[index] = el}  onClick={() => onClickTab(index)}><Styled.TabTitle>{screen.title}</Styled.TabTitle></Styled.TabNonActive>
                  }
                </>
              ))
            }
          </Styled.TabsInner>
        </Styled.Tabs>
        <Slider ref={sliderRef} { ...sliderSettings }>
          {
            servicesScreens.map(screen => screen.component)
          }
        </Slider>
      </>
    )
  }

  return (
    <>
      {
        !isMobile
          ? servicesScreens.map(screen => screen.component)
          : renderMobile()
      }
    </>
  )
}

export { ServicesScreenGroup }
